/** Pause control for Horizon's existing marquee; no extra animation engine. */
class CustomMarqueeControls extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const button = this.querySelector('.custom-promo-strip__pause');
    button?.addEventListener('click', () => {
      const paused = this.toggleAttribute('data-paused');
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('custom-marquee-controls')) customElements.define('custom-marquee-controls', CustomMarqueeControls);
